import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Link, } from 'react-router-dom';
import { ArrowBackIcon, ErrorLoginIcon, FalconLogo } from "../../icon";
import * as selector from '../../selectors/selectors';
import UnAuthComponent from '../layout/unauth.component';
import { AppRoutes } from '../routes/route.path';
import { appNote } from './constants';

interface IProps { }

const SsoInactiveScreen = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const params = useParams();
    let errorState = (params as any).state?.trim()


    return (
        <>

            <div className={` m-auto w-p-${IsMobileDevice ? "80" : "50"} br-4 px-3 py-4 container-width`} style={{ zIndex: 99999 }}>
                <FalconLogo
                    className=""
                />
                <div className={` mx-auto ${IsMobileDevice ? "" : "w-p-100"} o-y-auto`}>
                    <div className={"ml-2 w-fill d-flex"}>
                    </div>
                    <div className="ml-2 w-fill d-flex my-2">
                        <ErrorLoginIcon
                            width={260}
                            height={180} className="mx-auto" />
                    </div>
                    {errorState === "INVALID_EMAIL" && <div className="h1-semibold t-align-center mx-auto color-primary-light">Let's give it another shot</div>}
                    <div className="h3-semibold t-align-center color-microsoft-inactive"> Unfortunately, your attempt to log in to Falkon SMS was not successful.</div>
                    <div className='h3-semibold t-align-center color-microsoft-inactive'> Please try once again.</div>
                    {
                        errorState === "INVALID_EMAIL" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                            {/* <div className="h4-semibold">That email address doesn't exist</div> */}
                            <div className="h4-regular my-1 color-microsoft-inactive-email">The email address provided does not appear to be registered in Falkon SMS. Kindly review your entry and attempt again.</div>
                        </div>}

                    {errorState === "INACTIVE_PHONE_NUMBER" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                        {/* <div className="h4-semibold">Inactive Phone Number</div> */}
                        <div className="h4-regular my-1 color-microsoft-inactive-email"> Sorry, your Phone Number is inactive. Please contact your organization admin or <a className="underline" href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6" target="_blank" rel="noopener noreferrer">contact us </a> for further queries.</div>
                    </div>}
                    {errorState === "INACTIVE_ORGANIZATION" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                        {/* <div className="h4-semibold">Inactive organization</div> */}
                        <div className="h4-regular my-1 color-microsoft-inactive-email"> Sorry, your organization is disabled. Please <a className="underline" rel="noopener noreferrer" href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6" target="_blank">contact us </a> for further queries.</div>
                    </div>}
                    {errorState === "INACTIVE_USER" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                        {/* <div className="h4-semibold">Locked user</div> */}
                        <div className="h4-regular my-1 color-microsoft-inactive-email">Sorry, your account is locked. Please contact your organization admin or <a className="underline" rel="noopener noreferrer" href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6" target="_blank">contact us </a>for further queries.</div>
                    </div>}
                    {errorState === "PASSWORD_NOT_SET" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                        {/* <div className="h4-semibold">Pending User</div> */}
                        <div className="h4-regular my-1 color-microsoft-inactive-email">Sorry, Your have not set your account password. Please check your mail for Falkon SMS temporary password or <a className="underline" rel="noopener noreferrer" href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6" target="_blank">contact us </a>for further queries.</div>
                    </div>}
                    {
                        errorState === "ONLY_MICROSOFT_SSO_LOGIN_ALLOWED_FOR_THE_ORGANIZATION" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                            <div className="h4-regular my-1 color-microsoft-inactive-email">{appNote.ONLY_MICROSOFT_LOGIN_ALLOWED}</div>
                        </div>
                    }
                    {
                        errorState === "INACTIVE_SEAT_TYPE" && <div className="import-contacts-border p-2 bg-color-microsoft-inactive-bg br-2">
                            <div className="h4-regular my-1 color-microsoft-inactive-email">{appNote.SEAT_SUBSCRIPTION_CANCELED}</div>
                        </div>
                    }
                    <div className={"py-2 br-2 mb-2"}>
                        <span className={`my-auto mx-auto d-flex justify-center  align-center`}>
                            <Link
                                data-arrow-index={1}
                                data-up-arrow-index={1}
                                data-down-arrow-index={2}
                                data-left-arrow-index={1}
                                data-right-arrow-index={1}
                                tabIndex={3}
                                to={AppRoutes.SIGN_IN}
                            >
                                <span className="d-flex align-center">
                                    <ArrowBackIcon className={"c-pointer float-left w-2"}
                                    />
                                    <span className="h3-semibold ml-1 color-back-to-login d-flex"><span>{"Go back to "}</span>&nbsp;<span className="color-primary-light">falkonsms.com sign-in</span></span>
                                </span>
                            </Link>
                        </span>
                    </div>
                </div>
            </div >
        </>
    );
}


export default UnAuthComponent(SsoInactiveScreen);
